export const firebaseConfig = {
  apiKey: "AIzaSyCYfky8fP4ly0AmgAIG4AnUwJp9asojl10",
  authDomain: "kosturanov-f79a0.firebaseapp.com",
  projectId: "kosturanov-f79a0",
  storageBucket: "kosturanov-f79a0.appspot.com",
  messagingSenderId: "1001845071879",
  appId: "1:1001845071879:web:791f108e1bc5d517c6caa2"
};
